import { useCodeerApi, FetchMethod } from "../useCodeerApi"
import { EvaluatorSchema } from "./types"
import { Response, Evaluator } from "@/types"

export const useGetEvaluatorsApi = () => {
  return useCodeerApi<Response<EvaluatorSchema[]>>(
    "/eval/evaluators",
    FetchMethod.Get
  )
}

export {
  transToEvaluators as evaluatorsResponseToEvaluators,
  transToEvaluator as createEvaluatorResponseToEvaluator,
  transToEvaluator as updateEvaluatorResponseToEvaluator,
} from "./types"

export interface CreateEvaluatorRequest {
  name: string
  workspace_id: string
  description?: string
  system_prompt_template: string
  judge_llm_model_id?: string | null
}

export const makeCreateEvaluatorRequest = (
  name: string,
  systemPromptTemplate: string,
  workspaceId: string,
  description?: string,
  judgeLlmModelId?: string | null
): CreateEvaluatorRequest => {
  return {
    name,
    workspace_id: workspaceId,
    description,
    system_prompt_template: systemPromptTemplate,
    judge_llm_model_id: judgeLlmModelId,
  }
}

export interface UpdateEvaluatorRequest {
  name?: string
  description?: string
  system_prompt_template?: string
  judge_llm_model_id?: string | null
}

export interface SuggestEvaluatorSystemPromptRequest {
  name: string
  instruction: string
  primary_contents?: string
  system_prompt?: string
}

export interface SuggestEvaluatorSystemPromptResponse {
  system_prompt: string
}

export const makeUpdateEvaluatorRequest = (
  evaluator: Omit<Partial<Evaluator>, "judgeLlmModelId"> & {
    judgeLlmModelId?: string | null
  },
  currentJudgeLlmModelId?: string | null
): UpdateEvaluatorRequest => {
  const request: UpdateEvaluatorRequest = {
    name: evaluator.name,
    description: evaluator.description,
    system_prompt_template: evaluator.systemPromptTemplate,
  }

  if (
    evaluator.judgeLlmModelId !== undefined &&
    evaluator.judgeLlmModelId !== currentJudgeLlmModelId
  ) {
    request.judge_llm_model_id = evaluator.judgeLlmModelId
  }

  return request
}

export const useCreateEvaluatorApi = () => {
  return useCodeerApi<Response<EvaluatorSchema>, CreateEvaluatorRequest>(
    "/eval/evaluators",
    FetchMethod.Post
  )
}

export const useUpdateEvaluatorApi = () => {
  return useCodeerApi<Response<EvaluatorSchema>, UpdateEvaluatorRequest>(
    "/eval/evaluators",
    FetchMethod.Put,
    true,
    (params) => {
      return `/eval/evaluators/${params.evaluator_id}`
    }
  )
}

export const useDeleteEvaluatorApi = () => {
  return useCodeerApi<Response<{ message: string }>>(
    "/eval/evaluators",
    FetchMethod.Delete,
    true,
    (params) => {
      return `/eval/evaluators/${params.evaluator_id}`
    }
  )
}

export const useSuggestEvaluatorSystemPromptApi = () => {
  return useCodeerApi<
    Response<SuggestEvaluatorSystemPromptResponse>,
    SuggestEvaluatorSystemPromptRequest
  >(
    "/eval/workspaces",
    FetchMethod.Post,
    true,
    (params) =>
      `/eval/workspaces/${params.workspace_id}/evaluators/suggest-system-prompt`
  )
}
